<template>
  <div id="app-welfare" ref="welfare">
    <div class="welfare-box">
      <div class="welfare-top">
        <h3 :class="{'animated': classHide, 'fadeInLeft': classHide}">爱眼项目</h3>
        <div
          :class="{'more-box':classShow,'animated': classHide, 'fadeInRight': classHide}"
          style="cursor:pointer"
          @click="goMore"
        >
          <h6>更多</h6>
          <p>more</p>
        </div>
        <div :class="{'border-box':classShow, 'animated': classHide, 'fadeInUpBig': classHide,}"></div>
      </div>
      <div class="welfare-bottom">
        <div
          class="content-box"
          v-for="(item,index) in projectList"
          :key="index"
          :class="{'animated': classHide, 'fadeInUp': classHide}"
        >
          <a style="cursor: pointer;" @click="gotoProject(item.id)">
            <div class="img-box">
              <img v-lazy="item.news_pic_url" alt />
            </div>
            <div class="con-box">
              <h3>{{item.news_title}}</h3>
              <p>{{item.description}}</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      classHide: false,
      classShow: true,
      projectList: [], //项目列表数组
      webInfo: {}
    };
  },
  mounted() {
    this.getProjectList();
  },
  computed: {
    webData() {
      let info = this.$store.state.web_info;
      return info;
    }
  },

  watch: {
    webData: {
      handler(val) {
        if (val) {
          this.webInfo = val;
        }
      },
      immediate: true
    }
  },
  methods: {
    gotoProject(id) {
      this.$router.push({ path: "/projectDetails", query: { id: id } });
    },
    goMore() {
      if (this.webInfo.project_more > 0) {
        this.$router.push({
          path: "/pubIndex",
          query: { cid: this.webInfo.project_more }
        });
      }
    },
    getProjectList() {
      //获取首页项目列表
      this.$db.post(this.$db.config.getProjectIndexUrl, {}).then(res => {
        if (res.code == 200) {
          this.projectList = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#app-welfare {
  width: 100%;
  margin-bottom: 45px;
}

.welfare-box {
  width: 1300px;
  margin: 0 auto;
  .welfare-top {
    position: relative;
    margin-bottom: 70px;
    > h3 {
      font-size: 30px;
      color: #000;
      font-weight: normal;
      padding: 14px 0;
    }
    .more-box {
      position: absolute;
      right: 0;
      top: 20px;
      > p {
        font-size: 12px;
        color: #333333;
      }
      > h6 {
        font-size: 14px;
        color: #333333;
      }
    }
    .border-box {
      width: 1300px;
      height: 1px;
      border: 1px solid #c30d23;
      border-bottom: 3px solid #c30d23;
      animation-delay: 0.3s;
    }
  }
  .welfare-bottom {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .content-box {
      width: 410px;
      margin-bottom: 10px;
      animation-delay: 0.5s;
      margin-right: 35px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      > a {
        transition: ease-out 0.6s;
        display: block;
        &:hover {
          box-shadow: 0px 0px 35px 0px rgba(9, 1, 4, 0.21);
          .img-box {
            > img {
              transform: scale(1.05);
            }
          }
          .con-box {
            background-color: #c30d23;
            transition: all 1.5s;
            > h3 {
              color: #fff;
            }
            > p {
              color: #fff;
            }
            > ul {
              > li {
                > h5 {
                  color: #fff;
                }
                > p {
                  color: #740f1b;
                }
              }
            }
          }
        }
        .img-box {
          width: 100%;
          height: 290px;
          overflow: hidden;
          > img {
            width: 100%;
            height: 100%;
            transition: all 1s;
          }
        }
        .con-box {
          padding: 28px;
          height: 51px;
          > h3 {
            font-size: 18px;
            color: #333333;
            margin-bottom: 8px;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
          > p {
            font-size: 14px;
            color: #999;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
          > ul {
            display: flex;
            margin-top: 30px;
            > li {
              width: 50%;
              list-style: none;
              > h5 {
                font-size: 18px;
                color: #333333;
                margin-bottom: 8px;
                overflow: hidden;
              }
              > p {
                font-size: 14px;
                color: #999;
              }
            }
          }
        }
      }

      .news {
        margin-top: 50px;
      }
      .news-list {
        padding-right: 45px;
        padding-left: 10px;

        > li {
          list-style: none;
          margin-left: 10px;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          position: relative;

          > i {
            width: 3px;
            height: 3px;
            background-color: #000;
            border-radius: 50%;
            position: absolute;
            left: -8px;
            top: 50%;
            transform: translateY(-50%);
          }
          > p {
            width: 75%;
            font-size: 16px;
            color: #333;
            line-height: 21px;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
          > span {
            font-size: 14px;
            color: #999;
            line-height: 21px;
          }
          /*&:hover {
            > span {
              color: #c30d23;
            }
            > p {
              color: #c30d23;
            }
          } */
        }
        > a > p {
          font-size: 16px;
          line-height: 40px;
          color: #333333;
          border-top: 1px solid #ddd;
          text-align: right;
          border-top: 1px solid #ddd;
          cursor: pointer;
          &:hover {
            color: #c30d23;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/home_project.vue